export const SIDENAVBAR_CONTENT_WRAPPER = 'sidenavbar-content-wrapper';
